import React, { useEffect } from 'react';
import { number, shape, bool } from 'prop-types';
import clsx from 'clsx';
import useStore from 'state/state';
import { useSpring, animated } from 'react-spring';

import styles from './AnimatedBox.module.scss';

const AnimatedBox = ({
  firstPosition,
  secondPosition,
  isGreen,
  isBlue,
  // animateOut,
}) => {
  const setAnimatedBoxStartPosition = useStore(
    (state) => state.setAnimatedBoxStartPosition
  );
  const setAnimatedBoxEndPosition = useStore(
    (state) => state.setAnimatedBoxEndPosition
  );

  const props = useSpring({
    to: async (next) => {
      await next({
        top: `${secondPosition.top}px`,
        left: `${secondPosition.left}px`,
        width: `${secondPosition.width}px`,
        height: `${secondPosition.height}px`,
      });
      await next({ opacity: 0 });
    },
    from: {
      top: `${firstPosition.top}px`,
      left: `${firstPosition.left}px`,
      width: `${firstPosition.width}px`,
      height: `${firstPosition.height}px`,
      opacity: 1,
    },
    config: {
      // duration: 500,
      friction: 20,
      tension: 150,
      mass: 1.5,
    },
    // reset: animateOut,
    // reverse: animateOut,
  });

  useEffect(() => {
    setTimeout(() => {
      setAnimatedBoxStartPosition(null);
      setAnimatedBoxEndPosition(null);
    }, 1100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <animated.div
      style={props}
      className={clsx(styles.animatedContainer, {
        [styles.isGreen]: isGreen,
        [styles.isBlue]: isBlue,
      })}
    />
  );
};

AnimatedBox.propTypes = {
  firstPosition: shape({
    top: number,
    left: number,
    width: number,
    height: number,
  }).isRequired,
  secondPosition: shape({
    top: number,
    left: number,
    width: number,
    height: number,
  }).isRequired,
  isGreen: bool,
  isBlue: bool,
  // animateOut: bool.isRequired,
};

AnimatedBox.defaultProps = {
  isGreen: false,
  isBlue: false,
};

export default AnimatedBox;
